import { CommunicationTypes } from "../constants/communicationTypes";
import { DefaultOauthLink, LoginLink } from "../constants/general";
import { DomUtils } from "../utils/domUtils";
import { LocationUtils } from "../utils/locationUtils";
import { BaseController } from "./base";

export const SendCodeConstants = {
	pageTitle: "pageTitle",
	sendCodeForm: "sendCodeForm",
	sendText: "sendText",
	sendEmail: "sendEmail",
	maskedEmail: "maskedEmail",
	maskedPhone: "maskedPhone",
	sendCodeButton: "sendCodeButton",
	loginLink: "loginLink",
	token: "token",
	newAccount: "newAccount"
};

export class SendCodeController extends BaseController {
	constructor() {
		super();

		this._pageTitle = null;
		this._emailMasked = null;
		this._phoneLast4 = null;
		this._token = null;
		this._newAccount = false;
		this._nextStep = null;
		this._communicationType = null;
		this._sendCodeNotConfigured = false;
		this._loginLink = null;
		this._signIn = null;
		this._nextButton = null;
	}

	Init() {
		this._GetContextData();

		this._SetupTitle();
		this._SetupForm();

		this._BindEvents();
	}

	_GetContextData() {
		this._pageTitle = window.pageTitle;
		this._emailMasked = window.emailMasked;
		this._phoneLast4 = window.phoneLast4;
		this._token = window.token;
		this._newAccount = window.newAccount;
		this._nextStep = window.nextStep;
		this._nextButton = window.nextButton;

		this._signIn = LocationUtils.GetQueryParam("signin");

		if (!!this._signIn) {
			this._loginLink = `${LoginLink}${this._signIn}`;
		}
		else {
			this._loginLink = DefaultOauthLink;
		}

		if (!!this._emailMasked) {
			this._communicationType = CommunicationTypes.email;
		}
		else if (!!this._phoneLast4) {
			this._communicationType = CommunicationTypes.sms;
		}
		else {
			this._sendCodeNotConfigured = true;
		}

		this._recaptchaSiteKey = window.recaptchaSiteKey;
	}

	_SetupTitle() {
		this._localeService.SetElementTranslation(SendCodeConstants.pageTitle, this._pageTitle);
	}

	_SetupForm() {
		const sendCodeFormElement = DomUtils.GetElement(SendCodeConstants.sendCodeForm);
		const maskedEmailElement = DomUtils.GetElement(SendCodeConstants.maskedEmail);
		const maskedPhoneElement = DomUtils.GetElement(SendCodeConstants.maskedPhone);
		const loginLinkElement = DomUtils.GetElement(SendCodeConstants.loginLink);
		const tokenElement = DomUtils.GetElement(SendCodeConstants.token);
		const newAccountElement = DomUtils.GetElement(SendCodeConstants.newAccount);
		const sendTextElement = DomUtils.GetElement(SendCodeConstants.sendText);
		const sendEmailElement = DomUtils.GetElement(SendCodeConstants.sendEmail);

		sendCodeFormElement.action = `${this._nextStep}?signin=${this._signIn}`;
		maskedEmailElement.innerHTML = this._emailMasked;
		maskedPhoneElement.innerHTML = this._phoneLast4;
		loginLinkElement.href = this._loginLink;
		tokenElement.value = this._token;
		newAccountElement.value = this._newAccount;

		sendTextElement.value = CommunicationTypes.sms;
		sendEmailElement.value = CommunicationTypes.email;
	}

	_BindEvents() {
		this._BindSendCodeButton();
		this._BindRadioButtons();
	}

	_BindRadioButtons() {
		const sendEmailRadioElement = DomUtils.GetElement(SendCodeConstants.sendEmail);
		const sendTextRadioElement = DomUtils.GetElement(SendCodeConstants.sendText);
		const buttonElement = DomUtils.GetElement(SendCodeConstants.sendCodeButton);

		const enableButton = () => {
			buttonElement.disabled = false;
		};

		if (!!sendEmailRadioElement) {
			sendEmailRadioElement.addEventListener("click", enableButton);
		}

		if (!!sendTextRadioElement) {
			sendTextRadioElement.addEventListener("click", enableButton);
		}
	}

	_BindSendCodeButton() {
		const sendCodeButtonElement = DomUtils.GetElement(SendCodeConstants.sendCodeButton);

		if (!!sendCodeButtonElement) {
			sendCodeButtonElement.addEventListener("click", this._SendCode.bind(this));
		}
	}

	_SendCode() {
		if (this._Validate()) {
			this._SubmitForm();
		}
	}

	/* istanbul ignore next */
	_SubmitForm() {
		super._SubmitForm(SendCodeConstants.sendCodeForm);
	}

	_Validate() {
		const sendEmailRadioElement = DomUtils.GetElement(SendCodeConstants.sendEmail);
		const sendTextRadioElement = DomUtils.GetElement(SendCodeConstants.sendText);

		return sendEmailRadioElement.checked || sendTextRadioElement.checked;
	}
}
